module.exports = __webpack_public_path__ + "img/central.d0e8e21b.png";